/**
 * Isolated clock component — only this re-renders every second, not the
 * whole header. Memoized so the per-second tick stays local.
 */

import React, { memo, useEffect, useState } from "react";
import { Globe } from "lucide-react";
import { TIMEZONE_DATABASE } from "@/lib/timezones";

function WorldClocksImpl({ userClocks }) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => setTick((t) => t + 1), 1000);
    return () => clearInterval(timer);
  }, []);

  const getClockTime = (clockId, includeSeconds = false) => {
    const preset = TIMEZONE_DATABASE.find((p) => p.id === clockId);
    if (!preset) return "--:--";
    const now = new Date();
    const utc = now.getTime() + now.getTimezoneOffset() * 60000;
    const targetTime = new Date(utc + 3600000 * preset.offset);
    const options = { hour: "2-digit", minute: "2-digit", hour12: false };
    if (includeSeconds) options.second = "2-digit";
    return targetTime.toLocaleTimeString("en-US", options);
  };

  return (
    <div className="flex items-center gap-3 sm:gap-4">
      {userClocks.slice(0, 3).map((clock, idx) => (
        <div
          key={clock.id || idx}
          /* El TERCER reloj sólo aparece a partir de `xl`. Entre ~1000 y ~1100 px
             con la barra lateral desplegada los tres ya no caben, y como el
             header es `justify-between` con dos grupos que no encogen
             (`min-width: auto` sobre contenido rígido), el excedente no se
             recortaba: empujaba el grupo derecho —búsqueda, acciones, avatar—
             FUERA del viewport, y la app entera ganaba scroll horizontal.
             Medido: contenido 785 px contra 738 px de espacio útil.
             Se esconde en vez de encoger porque un reloj cortado a la mitad no
             se puede leer; el salto `sm→xl` es el mismo criterio con el que ya
             se pasa de 1 reloj a 3. */
          className={`items-center gap-1.5 text-xs sm:text-sm ${idx === 2 ? "hidden xl:flex" : "flex"}`}
        >
          {idx === 0 && <Globe className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-slate-500" />}
          <span className="font-mono tabular-nums text-white font-medium">
            {getClockTime(clock.id, idx === 0)}
          </span>
          <span className="text-[10px] sm:text-xs text-slate-400 uppercase tracking-wider">
            {clock.label || clock.id}
          </span>
        </div>
      ))}
    </div>
  );
}

const WorldClocks = memo(WorldClocksImpl);
export default WorldClocks;
